import a from "./img/1.avif"
import b from "./img/2.avif"
import c from "./img/3.avif"
import d from "./img/4.avif"
import e from "./img/5.avif"
import f from "./img/6.avif"
import g from "./img/7.avif"
import h from "./img/8.avif"
import i from "./img/9.avif"
import j from "./img/10.avif"


export const SHOE_DATA = [
    {
        id: 1,
        title: "Nike A",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: a,
        price: 100
    },
    {
        id: 2,
        title: "Nike B",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: b,
        price: 200
    },
    {
        id: 3,
        title: "Nike C",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: c,
        price: 150
    },
    {
        id: 4,
        title: "Nike J",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: j,
        price: 350
    },
    {
        id: 5,
        title: "Nike D",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: d,
        price: 500
    },
    {
        id: 6,
        title: "Nike E",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: e,
        price: 800
    },
    {
        id: 7,
        title: "Nike F",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: f,
        price: 750
    },
    {
        id: 8,
        title: "Nike G",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: g,
        price: 1000
    },
    {
        id: 9,
        title: "Nike H",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: h,
        price: 700
    },
    {
        id: 10,
        title: "Nike I",
        info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Nulla quis minima impedit iusto error.Vitae facere quis accusamus, id tempora dolor eligendi temporibus, facilis est placeat repudiandae sapiente totam nihil laudantium dolorum doloribus recusandae sed consequatur autem nobis quae.Quasi iste quam pariatur quaerat aspernatur ipsum atque cupiditate, officia molestias!",
        image: i,
        price: 100
    }
]